import * as React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { fetchPostWP } from '../actions/posts';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import renderHTML from 'react-render-html';
import { isEmpty } from '../helpers/index';
var phpUnserialize = require('../helpers/phpUnserialize');

class DetailGrocery extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			loading: true
		};
	}

	componentDidMount() {
		if (this.props.match.params.post_id) {
			this.props.fetchPostWP({
				post_id: this.props.match.params.post_id
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.postWP.loading == false) {
			this.setState({
				loading: false
			});
			document.title = nextProps.postWP.data.post_title;
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.postWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	render() {
		const { postWP } = this.props;

		var img_gallery = '';

		if (isEmpty(postWP.data)) {
			var data_img = phpUnserialize(postWP.data.custom_fields[0]['value']);
			if (data_img.length > 0) {
				img_gallery = data_img.map((item, index) => {
					if (index == 0) {
						return (
							<div key={item.id} className="images col-sm-12">
								<img src={require('../img/img-maskPrd600.png')}
								     style={{ background: `url(${item}) no-repeat center center/cover` }}/>
							</div>
						);
					} else {
						return (
							<div key={item.id} className="thumbnails columns-3 col-sm-4">
								<img src={require('../img/img-maskPrd.png')}
								     style={{ background: `url(${item}) no-repeat center center/cover` }}/>
							</div>
						);
					}
				});
			}
		}

		return (
			<div className="productsWrap">
				<div className="container">
					<div className="pageTitle">
						Cửa hàng
					</div>
					<div className="row">
						<div className="col-sm-12">
							<div className="shopProductsDetail">
								<div className="row">
									<div className="col-sm-6">
										<div className="row">
											{img_gallery}
										</div>
									</div>
									<div className="col-sm-6">
										<div className="product-summary">
											<div className="titlePrd">
												{postWP.data.post_title}
											</div>
											<div className="descriptionPrd content-responsive postContent">
												{renderHTML(`${postWP.data.post_content}`)}
												<div className="quantity">
													<a href="https://docs.google.com/forms/d/1_8tT4k5hfKVgWGgc66JYx2jrpruH4iRutXWr0zg0z4o/viewform?ts=5c821709&edit_requested=true" target="_blank">
														<button className="btn btn-submit">
															Đặt mua
														</button>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{this.state.loading ?
					<div className="loadingPage active"><img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'postWP'
]), mapDispatchToProps({
	fetchPostWP
}))(translate('translations')(DetailGrocery));



// WEBPACK FOOTER //
// ./src/containers/DetailGrocery.tsx